module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/october-4cb3bbcbb6bf2f7c7fd03ab49443e67e.png";